import getHostVariant, { EHostVariant } from './getHostVariant';

export default function isOnEmbedPage() {
  return /\/embed\//.test(window.location.href) || getHostVariant() === EHostVariant.Embedded;
}
